<template>
  <section
    id="message"
    class="co-bg-striped"
  >
    <div class="co-container-md mx-auto px-5 py-20 lg:px-0">
      <h2 class="co-display-7 mb-[3.25rem] text-center tracking-[.15em]">
        メッセージ
      </h2>
      <div class="mb-10 flex flex-col bg-co-gray-50 shadow-[0_0_4px_rgba(51,51,51,0.2)] md:flex-row">
        <div class="md:w-1/3 lg:w-1/4">
          <picture>
            <source
              media="(max-width: 767px)"
              srcset="~/assets/images/Te/TeCourse/Message/message-1-sm.jpg"
            >
            <img
              src="~/assets/images/Te/TeCourse/Message/message-1-lg.jpg"
              loading="lazy"
              alt="本気の方に最高のサポートをお安く"
            >
          </picture>
        </div>
        <div class="flex flex-col justify-center p-5 md:w-2/3 lg:w-3/4">
          <h3 class="co-display-9 mb-4 text-center tracking-[.15em] md:text-left">
            本気の方に最高のサポートをお安く
          </h3>
          <p class="mb-0 tracking-[.15em]">
            料金を見ると一見「高いかな？」と思われたかもしれません。<br class="hidden sm:block">
            ですが集合型ITスクールでは50〜100万円が相場で、サポートが薄いのが一般的。<br class="hidden sm:block">
            <slot name="chatch01">
              当スクールでは本気の方を徹底サポートすべく、<span class="bg-co-yellow-500">メンターの時間を毎日確保</span>。
            </slot>
            <br class="hidden sm:block">
            <span class="bg-co-yellow-500">挫折させない環境づくり</span>で、価格以上にご納得いただける内容だと自負しています。
          </p>
        </div>
      </div>
      <div class="mb-10 flex flex-col-reverse bg-co-gray-50 shadow-[0_0_4px_rgba(51,51,51,0.2)] md:flex-row">
        <div class="flex flex-col justify-center p-5 md:w-2/3 lg:w-3/4">
          <h3 class="co-display-9 mb-4 text-center tracking-[.15em] md:text-left">
            勉強は一瞬、スキルは一生
          </h3>
          <p class="mb-0 tracking-[.15em]">
            勉強時間の確保は大変のように感じますが、長い人生の中では一瞬の出来事です。<br class="hidden sm:block">
            <slot name="chatch02">
              プログラミング
            </slot>
            というスキルは
            <slot name="chatch03">
              <span class="bg-co-yellow-500">アイデアをカタチにするためのツール</span>
            </slot>
            です。
            <br class="hidden sm:block">
            <slot name="chatch04">
              そのスキルは仕事にも趣味にも、そして新しい価値を生み出すことにも使えます。
            </slot>
            <br class="hidden sm:block">
            <span class="bg-co-yellow-500">一生モノのスキル</span>をできるだけ多くの方に手に入れて欲しいと考えています。
          </p>
        </div>
        <div class="md:w-1/3 lg:w-1/4">
          <picture>
            <source
              media="(max-width: 767px)"
              srcset="~/assets/images/Te/TeCourse/Message/message-2-sm.jpg"
            >
            <img
              src="~/assets/images/Te/TeCourse/Message/message-2-lg.jpg"
              loading="lazy"
              alt="勉強は一瞬、スキルは一生"
            >
          </picture>
        </div>
      </div>
    </div>
  </section>
</template>
